module.exports = __webpack_public_path__ + "static/media/erp_circle.310df5b8.svg";